import type { AssessmentRemoteDataSource } from '../datasources/AssessmentRemoteDataSource.js';
import {
  toAssessmentDbRow,
  toAssessmentEntity,
  toAssessmentResponseEntity,
} from '../dtos/AssessmentDto.js';
import type {
  AssessmentEntity,
  AssessmentResponseEntity,
} from '../../domain/entities/AssessmentEntity.js';

export class AssessmentRepository {
  constructor(private dataSource: AssessmentRemoteDataSource) {}

  async list(projectId: string): Promise<AssessmentEntity[]> {
    const rows = await this.dataSource.list(projectId);
    return rows.map(toAssessmentEntity);
  }

  async getById(id: string): Promise<AssessmentEntity | null> {
    const row = await this.dataSource.getById(id);
    return row ? toAssessmentEntity(row) : null;
  }

  async create(entity: Partial<AssessmentEntity>): Promise<AssessmentEntity> {
    const row = toAssessmentDbRow(entity);
    const createdRow = await this.dataSource.create(row);
    return toAssessmentEntity(createdRow);
  }

  async update(id: string, patch: Partial<AssessmentEntity>): Promise<AssessmentEntity> {
    const row = toAssessmentDbRow(patch);
    const updatedRow = await this.dataSource.update(id, row);
    return toAssessmentEntity(updatedRow);
  }

  async delete(id: string): Promise<void> {
    await this.dataSource.delete(id);
  }

  async listResponses(assessmentId: string): Promise<AssessmentResponseEntity[]> {
    const rows = await this.dataSource.listResponses(assessmentId);
    return rows.map(toAssessmentResponseEntity);
  }
}
